export enum PlanSubscriptionDeactivationReasonType {
    None = 0,
    Expired,
    CanceledByUser,
    CanceledByAdmin,
    PaymentFailed,
    System
}